import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import Layout from '../components/Layout';

const ActivateAccount = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const activateAccount = async () => {
      try {
        setLoading(true);
        const response = await api.post(`/accounts/activate/${uid}/${token}/`);
        setMessage(response.data.message || 'Konto zostało aktywowane pomyślnie!');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (err) {
        setError(
          err.response?.data?.error ||
          err.response?.data?.detail ||
          'Nie udało się aktywować konta. Link może być nieprawidłowy lub wygasły.'
        );
      } finally {
        setLoading(false);
      }
    };

    activateAccount();
  }, [uid, token, navigate]);

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          {loading ? (
            <div className="text-center">
              <div className="text-ik-orange text-xl mb-4">Aktywowanie konta...</div>
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-ik-orange mx-auto"></div>
            </div>
          ) : error ? (
            <div className="bg-white rounded-lg shadow-md p-8">
              <div className="text-center">
                <div className="text-red-600 text-4xl mb-4">✕</div>
                <h2 className="text-2xl font-bold text-ik-black mb-4">Błąd aktywacji</h2>
                <p className="text-gray-600 mb-6">{error}</p>
                <Link
                  to="/register"
                  className="inline-block px-6 py-2 bg-ik-orange text-white rounded-lg hover:bg-orange-600 transition"
                >
                  Zarejestruj się ponownie
                </Link>
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-lg shadow-md p-8">
              <div className="text-center">
                <div className="text-green-600 text-4xl mb-4">✓</div>
                <h2 className="text-2xl font-bold text-ik-black mb-4">Konto aktywowane!</h2>
                <p className="text-gray-600 mb-6">{message}</p>
                <p className="text-sm text-gray-500 mb-6">
                  Zostaniesz przekierowany do strony logowania za chwilę...
                </p>
                <Link
                  to="/login"
                  className="inline-block px-6 py-2 bg-ik-orange text-white rounded-lg hover:bg-orange-600 transition"
                >
                  Przejdź do logowania
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ActivateAccount;
